module.exports = __webpack_public_path__ + "img/About_content_Graph2.faf5cd6c.png";